import { PartnershipTypes } from 'constants/partnership';

import { isSelectedPartnerTypeNew } from 'helpers/searchCompanies';

/**
 * Returns the existing partnership type that is only recorded on the ledger
 * @param {object} selectedCompany
 * @returns {string}
 */
export const getExistingPartnershipMatchType = (selectedCompany) => {
  if (selectedCompany.isLedgerOnly && selectedCompany.isCustomer) {
    return PartnershipTypes.CUSTOMER;
  }

  return PartnershipTypes.VENDOR;
};

/**
 * Returns the required partnership type needed to match partner to Routable
 * @param {object} selectedCompany
 * @returns {string}
 */
export const getRequiredPartnershipMatchType = (selectedCompany) => {
  if (selectedCompany.isLedgerOnly && selectedCompany.isCustomer) {
    return PartnershipTypes.VENDOR;
  }

  return PartnershipTypes.CUSTOMER;
};

/**
 * Returns whether the currently selected partner company is existing.
 * @param {Object} selectedCompany
 * @returns {boolean}
 */
export const isSelectedCompanyExisting = (selectedCompany) =>
  !!selectedCompany && !isSelectedPartnerTypeNew(selectedCompany.type);
